const updateSummaryField = function ({ target }) {
  const fieldName = target.getAttribute('name');
  const spanEl = this.closest('subscription-quiz')?.querySelector(`[data-answer-name="${fieldName}"]`);

  if (spanEl) spanEl.innerHTML = target.closest('.coffee-group') ? target.dataset.title : target.value;
}

class SubscriptionQuiz extends HTMLElement {
  constructor() {
    super();
    this.tooltipTrigger = this.querySelector('.tooltip__tool');

    this.addEventListener('click', this.handleClick.bind(this));
    this.addEventListener('mouseenter', this.handleMouseEnterLeave.bind(this));
    this.addEventListener('mouseleave', this.handleMouseEnterLeave.bind(this));
  }

  handleClick({ target }) {
    if (!target.classList.contains('tooltip__close')) return;

    target.closest('.tooltip')?.classList.add('hidden');
  }

  handleMouseEnterLeave({ type }) {
    switch (type) {
      case 'mouseenter':
        this.tooltipTrigger.parentElement.classList.add('show-background');
        break;

      case 'mouseleave':
        this.tooltipTrigger.parentElement.classList.remove('show-background');

      default:
        break;
    }
  }
}

customElements.define('subscription-quiz', SubscriptionQuiz);

class SubscriptionQuizGroup extends HTMLElement {
  constructor() {
    super();

    this.updateSummaryField = updateSummaryField;
    this.addEventListener('change', this.scrollToNextQuizGroup.bind(this));
  }

  scrollToNextQuizGroup({ currentTarget, target }) {
    const { nextElementSibling } = currentTarget;
    const { type } = target.dataset;

    this.showCorrespondingRoast({ target });
    this.setShippingInterval({ target });

    if (type == 'product_link') {
      const url = target.value;
      this.getProductInfo(url);
    }

    if (
      nextElementSibling?.classList.contains('subscribe__quiz-group')
      || nextElementSibling?.classList.contains('subscribe__quiz-summary')
      || nextElementSibling?.dataset?.section === 'subscription-product'
    ) nextElementSibling.scrollIntoView();
    else if (
      currentTarget.parentElement.nextElementSibling?.classList.contains('subscribe__quiz-group')
    ) currentTarget.parentElement.nextElementSibling.scrollIntoView();
  }

  setShippingInterval({ target }) {
    if (target.name !== 'frequency') return;

    const intervalTypeInput = document.querySelector('[name="properties[shipping_interval_unit_type]"]');
    const intervalFrenquencyInput = document.querySelector('[name="properties[shipping_interval_frequency]"]');

    if (target.value.includes('weekly') && intervalTypeInput) {
      intervalTypeInput.value = 'Weeks'
    } else {
      intervalTypeInput.value = 'Months'
    }

    if (target.value.includes('bi') && intervalFrenquencyInput) {
      intervalFrenquencyInput.value = '2'
    } else {
      intervalFrenquencyInput.value = '1'
    }
  }

  showCorrespondingRoast({ target }) {
    if (!target.closest('.coffee-group')) return;

    const { nextElementSibling } = target.closest('.coffee-group');

    nextElementSibling?.querySelector('.subscribe__answer.active')?.classList.remove('active');
    nextElementSibling?.querySelector(`[data-index="${target.value}"]`)?.classList.add('active');
  }

  repopulateCoffee() {
    const coffeeType = [...document.querySelectorAll('.subscribe__quiz-inner input')].filter((input) => input.checked && input.name === 'coffee');

    coffeeType.forEach(type => this.updateSummaryField({ target: type }));
  }

  async getProductInfo(url) {
    const response = await fetch(url);
    const responseText = await response.text();

    const html = new DOMParser().parseFromString(responseText, 'text/html')

    const selector = '[data-section="subscription-product"] .js-contents';
    const destination = document.querySelector(selector);
    const source = html.querySelector(selector);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
    };

    this.repopulateCoffee();
  }
}

customElements.define('quiz-group', SubscriptionQuizGroup);

class SubscriptionSummary extends HTMLElement {
  constructor() {
    super();
    this.QUESTIONS_TOTAL = 4;
    this.updateSummaryField = updateSummaryField
    this.closest('subscription-quiz')?.addEventListener('change', this.showSummary.bind(this));
  }

  showSummary({ target }) {
    this.updateSummaryField({ target });
    if (this.getAllSelectedInputs().length === this.QUESTIONS_TOTAL) this.classList.remove('hidden');
  }

  getAllSelectedInputs() {
    return [...document.querySelectorAll('.subscribe__quiz-inner input')].filter((input) => input.checked)
  }
}

customElements.define('subscription-summary', SubscriptionSummary);


class SubscriptionVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.subscribePrice = document.querySelector('subscription-summary .subscribe__price')
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
    } else {
      this.updateVariantInput();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantInput() {
    const productForm = this.querySelector('input').form;
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    if (this.subscribePrice) this.subscribePrice.innerText = `$${this.currentVariant.price / 100}`;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('subscription-variant-radios', SubscriptionVariantRadios);
